<template>
  <!-- 作業予定お知らせ確認画面 -->

  <v-container>
    <v-row>
      <v-col cols="2" class="noBotPadding">
        <RyouSelect :label="'物件グループ名'" :items="buildGroupItems" :itemText="'build_group_name'"
                    :itemValue="'build_group_id'" v-model="buildGroupSelectValue" :value="buildGroupSelectValue">
        </RyouSelect>
      </v-col>
      <v-col cols="2" class="noBotPadding">
        <RyouSelect :label="'物件名'" :items="buildingItems" :itemText="'building_name'"
                    :itemValue="'building_id'" v-model="buildingSelectValue" :value="buildingSelectValue">
        </RyouSelect>
      </v-col>
      <v-col cols="6" sm="4" md="4" lg="4" class="noBotPadding">
        <RyouSelect :label="'作業区分選択'" :items="workClassItems" :itemText="'code_text'"
              :itemValue="'code_value'" v-model="workSelectValue" :value="workSelectValue">
  </RyouSelect>
      </v-col>
    </v-row>
    <v-card flat>
      <calendar-dialog ref="calendarDialog" :getGeneralFunc="getItemLists"></calendar-dialog>
    </v-card>
  </v-container>


</template>

<script>
  import CalendarDialog from "./modules/CalendarDialog.vue"
  import RyouSelect from "../../components/formInput/RyouSelect";

  export default {
    name: "noticeWorkScheduleConfirmation",
    components: {
      CalendarDialog,
      RyouSelect
    },
    mounted() {
      this.initData();
    },
    data() {
      return {
        p2Form: true,
        buildGroupItems: [],        //物件グループリスト
        buildingItems: [],          //物件リスト
        workClassItems: [],         //作業区分リスト
        userClassItems:[],          //利用者区分リスト
        buildGroupSelectValue: "",  //選択物件グループ
        buildingSelectValue: "",    //選択物件
        workSelectValue: "",        //選択作業区分リスト
      }
    },
    created() {
    },
    watch: {
      buildGroupSelectValue(value) {
        //物件一覧を取得
        let params = {
          build_group_id: value,
        }
        this.getRequest("/noticeWorkScheduleConfirmation/buildingGet", params, this.$store.getters.getUserToken).then(data => {
          if (data.success && data.status == "200") {
            var mapDatas = data.result.map(item => {
              item.building_id = String(item.building_id)
              return item
            });
            this.buildingItems = mapDatas;
            this.buildingItems.push("")
          }
        });

        //作業予定データをDBより取得する
        this.$refs.calendarDialog.fetchWorkSchdule(this.buildGroupSelectValue, this.buildingSelectValue, this.workSelectValue);
      },
      workSelectValue() {
        //作業予定データをDBより取得する
        this.$refs.calendarDialog.fetchWorkSchdule(this.buildGroupSelectValue, this.buildingSelectValue, this.workSelectValue);
      },
      buildingSelectValue() {
        //作業予定データをDBより取得する
        this.$refs.calendarDialog.fetchWorkSchdule(this.buildGroupSelectValue, this.buildingSelectValue, this.workSelectValue);
      }

    },
    methods: {
      //DBからデータを取得する
      initData() {

        //物件グループ一覧を取得
        let params = {
          userId: this.$store.getters.getUserId,
          userClass: this.$store.getters.getUserClass,
        }
        this.getRequest("/noticeWorkScheduleConfirmation/buildGroupGet", params, this.$store.getters.getUserToken).then(data => {
          if (data.success && data.status == "200") {
            var mapDatas = data.result.map(item => {
              item.build_group_id = String(item.build_group_id)
              return item
            });
            this.buildGroupItems = mapDatas;
          }
        });

        //作業区分一覧を取得する
        this.getRequest("/noticeWorkScheduleConfirmation/workClassGet", null, this.$store.getters.getUserToken).then(data => {
          if (data.success && data.status == "200") {
            this.workClassItems = data.result;
          }
        });

        //利用者区分一覧を取得する
        this.getRequest("/noticeRegistration/selectListGet", params, this.$store.getters.getUserToken).then(data => {
          if (data.success && data.status == "200") {
            this.userClassItems = data.result[0].children; //通知先
          }
        });
      },
      getItemLists(param) {
        if (param == 1) {
          return this.buildGroupItems;
        } else if (param == 2) {
          return this.workClassItems;
        } else if (param == 3) {
          return this.userClassItems;
        }
      },
    },
    computed: {
    },
  };
</script>

<style>
  /*要素のパディング領域の下の高さを設定*/
  .noBotPadding {
    padding-bottom: 0px;
  }
</style>
